import { LoadingOutline } from '@olist/design-system-icons';
import { margins } from '@olist/styled-system';
import styled, { css, keyframes } from 'styled-components';
import { DEFAULT_VALUE_VARIATION } from './constants.js';
import { focusContainer } from '../../utils/focusContainer.js';
import { opacityDisabled } from '../../utils/opacityDisabled.js';

const SMALL_ICON_SIZE = '16px';
const DEFAULT_ICON_SIZE = '24px';
const StyledButton = styled.button(({ variation = DEFAULT_VALUE_VARIATION, disabled, size = 'small', fixed, hasChildren, isLoading, theme: { olist: { components: { button }, }, }, }) => css `
    position: relative;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: none;
    text-decoration: none;

    padding: ${hasChildren
    ? button.default.size[size].padding
    : button.icon.padding[size]};
    font-size: ${button.default.size[size]['font-size']};
    font-family: ${button.default['font-family']};
    font-weight: ${button.default['font-weight']};
    line-height: ${button.default.size[size]['line-height']};
    letter-spacing: ${button.default['letter-spacing']};

    border-radius: ${button.default.radius};

    background-color: ${button.default.styles[variation].rest['background-color']};
    color: ${isLoading
    ? 'transparent'
    : button.default.styles[variation].rest.color};
    border-width: ${button.default.styles[variation].rest['border-width']};
    border-color: ${button.default.styles[variation].rest['border-color']};
    border-style: ${button.default.styles[variation].rest['border-style']};

    ${disabled
    ? opacityDisabled
    : css `
          &:hover {
            background-color: ${button.default.styles[variation].hover['background-color']};
            color: ${isLoading
        ? 'transparent'
        : button.default.styles[variation].hover.color};
            box-shadow: ${button.default['box-shadow']};
          }

          &:active {
            background-color: ${button.default.styles[variation].active['background-color']};
            color: ${isLoading
        ? 'transparent'
        : button.default.styles[variation].active.color};
          }

          ${focusContainer() ``}
        `}
    transition: 400ms ease;

    ${fixed &&
    css `
      width: 100%;
    `}

    ${margins}
  `);
const I = styled.span(({ size, iconLeft, centralized, theme: { olist: { components: { button }, }, }, }) => css `
    display: flex;
    transform: ${!centralized &&
    css `translateX(
      ${iconLeft ? '-' : ''}${button.default.size[size || 'small']['icon-position']})`};

    svg {
      width: ${size === 'small' ? SMALL_ICON_SIZE : DEFAULT_ICON_SIZE};
      height: ${size === 'small' ? SMALL_ICON_SIZE : DEFAULT_ICON_SIZE};
    }
  `);
const loadingAnimation = keyframes `
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;
const StyledLoadingIcon = styled(LoadingOutline)(({ variation = DEFAULT_VALUE_VARIATION, size, theme: { olist: { components: { button }, }, }, }) => css `
    position: absolute;
    animation: ${loadingAnimation};
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-fill-mode: forwards;
    animation-timing-function: linear;
    fill: ${button.default.styles[variation].rest.color};

    width: ${size === 'small' ? SMALL_ICON_SIZE : DEFAULT_ICON_SIZE};
    height: ${size === 'small' ? SMALL_ICON_SIZE : DEFAULT_ICON_SIZE};

    path {
      fill: ${button.default.styles[variation].rest.color};
    }
  `);

export { I, StyledButton, StyledLoadingIcon };
